module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/assessment_achievements/5@2x_ad9cff26305e348d7b7f519055933842.png";